module.exports = __webpack_public_path__ + "static/media/ic_woman.88979990.svg";